import { render } from "./TombamentoPlanilhaView.vue?vue&type=template&id=283af60f&scoped=true"
import script from "./TombamentoPlanilhaView.vue?vue&type=script&lang=js"
export * from "./TombamentoPlanilhaView.vue?vue&type=script&lang=js"

import "./TombamentoPlanilhaView.vue?vue&type=style&index=0&id=283af60f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283af60f"]])

export default __exports__